(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var mensajes = document.querySelectorAll('.formulario-contacto__mensaje');
    mensajes.forEach(function (mensaje) {
      mensaje.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    var formularios = document.querySelectorAll('.formulario-contacto__form');
    formularios.forEach(function (formulario) {
      formulario.addEventListener('submit', function () {
        var boton = formulario.querySelector('.formulario-contacto__boton');
        if (boton && !boton.disabled) {
          boton.disabled = true;
          boton.dataset.textoOriginal = boton.textContent;
          boton.textContent = 'Enviando...';
        }
      });
    });
  });
})();
